export default __webpack_public_path__ + "static/song-bg3@2x-09900dff82331601ba540cef27fbe144.jpg";